import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../../layouts/dashboard/default"));
const AllCity = lazy(() => import("../pages/all-city"));

export const CityRouter = [
  {
    path: "/master-management/city",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "all",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllCity />
          </Suspense>
        ),
      },
    ],
  },
];
